module.exports = __webpack_public_path__ + "public/img/camera.fcf12f3c.png";